import script from "./pc-module-cross-analysis-4.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-cross-analysis-4.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-cross-analysis-4.vue?vue&type=style&index=0&id=6e624bd7&lang=scss"

const __exports__ = script;

export default __exports__